<ng-container *transloco="let t">

    <h2>{{ t('Company Rankings') }} {{ t('for') }} {{month}}</h2>

    <ng-container *ngIf="!rankings"><img src="/assets/images/loading1.gif" title="Loading" ></ng-container>

  <ng-container *ngIf="rankings">


    <div class="justify-content-between">
      <button type="button" [cModalToggle]="tellmemoreModal.id" cButton style="width: fit-content" class="btn-light float-end">{{ t('Tell Me More About Company Rankings') }}</button>
      {{ t('Here is your company ranking for') }} {{month}}. <br/><br/>
    </div>
    <c-modal #tellmemoreModal alignment="center" id="tellmemoreModal">
      <c-modal-header>
        {{ t('More Info About Company Rankings') }}
      </c-modal-header>
      <c-modal-body>
        <p>
          {{ t("Company rankings show how your company's safety scores compare to other companies in your country and in the world.") }}
        </p>

        <p>
          {{ t('To calculate your company score, we take the average of your top 5 workers for this month. To be included in the ranking you must have at least 5 workers with a score of more than 0.') }}</p>

        <p>
          {{ t('If you are not in Canada, The United Kingdom, The United States or Australia - we include you in the Rest of the World and your country ranking includes countries such as New Zealand, Norway, Malaysia and Germany.') }}</p>
      </c-modal-body>
    </c-modal>

    <c-row>
      <c-col class="col-12 col-lg-6" *ngIf="u.isMainCountry(okService.settings.country)">
        <h3><img src="https://flagcdn.com/w40/{{okService.settings.country.toLowerCase()}}.png" title=""> {{ t('Rankings for your Country') }}</h3>
        <c-card>
          <table
          [hover]="true"
          [responsive]="true"
          [striped]="true"
          align="middle"
          cTable
          class="mb-0 border"
          >
          <tbody>
            <tr *ngFor="let rank of rankings.country_rankings" [class.table-success]="!rank.company.includes('**')">
              <td>{{rank.place}}</td>
              <td><span [class.hide-name]="rank.company.includes('**')">{{rank.company}}</span></td>
            </tr>
          </tbody>
          </table>
        </c-card>
      </c-col>
      <c-col class="col-12 col-lg-6">
        <h3><img src="assets/images/world.png" alt="World"> {{ t('World Wide Ranking') }}</h3>
        <c-card >
          <table
          [hover]="true"
          [responsive]="true"
          [striped]="true"
          align="middle"
          cTable
          class="mb-0 border"
          >
          <tbody>
            <tr *ngFor="let rank of rankings.world_rankings" [class.table-success]="!rank.company.includes('**')">
              <td>{{rank.place}}</td>
              <td><span [class.hide-name]="rank.company.includes('**')">{{rank.company}}</span></td>
              <td><img src="https://flagcdn.com/w40/{{rank.country.toLowerCase()}}.png" title="{{rank.country}}"></td>
            </tr>
          </tbody>
          </table>
        </c-card>
      </c-col>
    </c-row>
  </ng-container>
</ng-container>
